import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, Jsonp } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/mergeMap';
import'rxjs/add/operator/publishReplay';
export class ApiService {
/**
 * @param {?} _http
 * @param {?} _jsonp
 */
constructor(private _http: Http,
private _jsonp: Jsonp) { }
/**
 * Sends an asynchronous JSONP request
 * @template T
 * @param {?} url
 * @return {?}
 */
public jsonp<T>(url: string): Observable<T> {
    return this._jsonp.get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }
/**
 * Sends an asynchronous GET request
 * @template T
 * @param {?} url
 * @return {?}
 */
public get<T>(url: string): Observable<T> {
    let /** @type {?} */ headers = new Headers({ 
      'Content-Type': 'application/javascript',
    });
    let /** @type {?} */ options = new RequestOptions({ headers: headers });

    return this._http.get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
/**
 * Sends an asynchronous POST request
 * @template T
 * @param {?} url
 * @param {?} data
 * @return {?}
 */
public post<T>(url: string, data: T): Observable<T> {
    let /** @type {?} */ headers = new Headers({ 'Content-Type': 'application/json' });
    let /** @type {?} */ options = new RequestOptions({ headers: headers });

    return this._http.post(url, data, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
/**
 * @template T
 * @param {?} requestUrl
 * @param {?} data
 * @param {?=} additionalHeaders
 * @return {?}
 */
public postFormData<T>(requestUrl: string, data: FormData, additionalHeaders?: any): Observable<T> {
    const /** @type {?} */ headers = new Headers(additionalHeaders);
    const /** @type {?} */ options = new RequestOptions({ headers: headers });
    return this._http.post(requestUrl, data, options)
      .map(this.extractData)
      .catch(this.handleError)
      .publishReplay(1)
      .refCount();
  }
/**
 * @template T
 * @param {?} res
 * @return {?}
 */
private extractData<T>(res: Response) {
    let /** @type {?} */ body = res.json();
    return /** @type {?} */(( <T>body))|| /** @type {?} */(( <T>{}));
  }
/**
 * @param {?} error
 * @return {?}
 */
private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let /** @type {?} */ errMsg: string;
    if (error instanceof Response) {
      const /** @type {?} */ body = error.json() || '';
      const /** @type {?} */ err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);
    return Observable.throw(errMsg);
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: Jsonp, },
];
}

function ApiService_tsickle_Closure_declarations() {
/** @type {?} */
ApiService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ApiService.ctorParameters;
/** @type {?} */
ApiService.prototype._http;
/** @type {?} */
ApiService.prototype._jsonp;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
